import { Avatar, Box, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material';
import { setSelectedItem } from 'app/actions/driver';
import { Autosizer, Image, Scrollbar } from 'app/components';
import { selectedItemSelector, sortItemsSelector } from 'app/selectors/driver';
import React, { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FixedSizeList } from 'react-window';
const DriverList = () => {
    const dispatch = useDispatch();
    const selectedItem = useSelector(selectedItemSelector);
    const sortItems = useSelector(sortItemsSelector);
    const handleItemClick = (value) => dispatch(setSelectedItem(value));
    return (React.createElement(Box, { component: 'div', sx: (theme) => ({
            width: '100%',
            height: '100%',
            padding: theme.spacing(0),
            '.simplebar-offset > div': {
                '&::-webkit-scrollbar': {
                    width: 0,
                },
                '&::-webkit-scrollbar-track': {
                    background: 'transparent',
                    boxShadow: 'none',
                },
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                },
            },
            '.MuiListItem-root': {
                width: '100%',
                userSelect: 'none',
                padding: theme.spacing(0),
                borderRadius: '0',
                '.MuiListItemAvatar-root': {
                    minWidth: '36px',
                },
                '.MuiAvatar-circular': {
                    width: '24px',
                    height: '24px',
                },
                '.MuiListItemButton-root': {
                    padding: theme.spacing(1, 2),
                    borderRadius: '0',
                },
                '.MuiListItemText-root': {
                    margin: theme.spacing(0),
                },
            },
        }) },
        React.createElement(Autosizer, null, ({ height, width }) => (React.createElement(Box, { sx: { height, width } },
            React.createElement(Scrollbar, null, ({ scrollableNodeRef, contentNodeRef }) => (React.createElement(FixedSizeList, { height: height, itemSize: 36, itemCount: sortItems.length, innerRef: contentNodeRef, outerRef: scrollableNodeRef, innerElementType: driverListInnerElementType, itemData: {
                    items: sortItems,
                    selectedItem,
                    onClick: handleItemClick,
                } }, driverListItemRender))))))));
};
const driverListInnerElementType = forwardRef((props, ref) => (React.createElement(List, Object.assign({ ref: ref, disablePadding: true }, props))));
driverListInnerElementType.displayName = 'DriverListInnerElementType';
const driverListItemRender = ({ data, index, style }) => {
    const { items, selectedItem, onClick } = data;
    const item = items[index];
    return (React.createElement(ListItem, { key: item.id, style: style, selected: item.id === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id), onClick: () => onClick(item) },
        React.createElement(ListItemButton, null,
            React.createElement(ListItemAvatar, null,
                React.createElement(Avatar, null,
                    React.createElement(Image, { name: 'avatar-driver.png', alt: 'avatar-driver.png' }))),
            React.createElement(ListItemText, { primary: item.name }))));
};
export default DriverList;
